import { Header } from 'components/molecules';
import { ListBotTemplate } from 'components/templates';
import { withAuth } from 'HOCs';

const breadcrumbs = [{ label: 'Administración' }];

const ListBotPage = () => {
  return (
    <>
      <Header
        title="Bots"
        subtitle="Administra tus bots"
        breadCrumbsProps={{ breadcrumbs: breadcrumbs }}
      />
      <ListBotTemplate />
    </>
  );
};

export default withAuth(ListBotPage, undefined, 'mayasoft');
